module.exports = __webpack_public_path__ + "static/assets/54a8b99d398ba0b22d682e9455529b94.svg";